var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SortableTable',{attrs:{"rows":_vm.statusRows,"headers":_vm.statusHeaders,"table-actions":false,"row-actions":false,"key-field":"key","default-sort-by":"state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }